var pageSizeDefault = 20;
var pageSizeOptions = [10,20,50,100];

// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.variants.variant', {
        url:'/{variantId}?currentPage&filter&pageSize',
        views: {"productView@product": {
            templateUrl: 'main/product/variants/variant/variant.tpl.html',
            controller: 'VariantController as vm'
        }},
        resolve: {
            variant: variantResolver,
            variantGroups: variantGroupsResolver,
            variantDetails: variantDetailsResolver,
            searchTerms: searchTermsResolver
        }
    });
}

// @ngInject
function variantResolver($stateParams, VariantsApiService) {
    return VariantsApiService.getVariant($stateParams.variantId);
}

// @ngInject
function variantGroupsResolver($stateParams, VariantsApiService) {
    return VariantsApiService.getVariantGroupsByVariantId($stateParams.variantId);
}

// @ngInject
function variantDetailsResolver($stateParams, VariantsApiService) {
    if (!$stateParams.currentPage || $stateParams.currentPage < 1) { $stateParams.currentPage = 1; }
    if (!$stateParams.filter) { $stateParams.filter = ''; }
    if (!$stateParams.pageSize || $stateParams.pageSize < pageSizeDefault) { $stateParams.pageSize = pageSizeDefault; }
    return VariantsApiService.getVariantDetails($stateParams.variantId, $stateParams.currentPage, $stateParams.filter, $stateParams.pageSize);
}

// @ngInject
function searchTermsResolver($stateParams) {
    return {
        filter: $stateParams.filter,
        currentPage: $stateParams.currentPage,
        pageSize: $stateParams.pageSize
    };
}

// @ngInject
function VariantController($stateParams, $scope, variant, variantDetails, loadSpinnerService, VariantsApiService, variantGroups, searchTerms) {
    var vm = this;

    // Properties
    vm.variantDetails = variantDetails.data.results;
    vm.filter = '';
    vm.currentPage = 1;
    vm.pageSizeOptions = pageSizeOptions;
    vm.totalItems = variantDetails.data.total;
    vm.variantGroups = variantGroups;
    vm.variant = variant;

    // Functions
    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveVariant = saveVariant;
    vm.isEditing = vm.isNewVariant;
    vm.isAllInformationValid = isAllInformationValid;
    vm.orgDetails = [];
    vm.loadVariantDetails = loadVariantDetails;
    vm.searchTermChange = searchTermChange;

    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactVariantView') !== 'false';

    activate();

    function activate() {
        if (searchTerms) {
            vm.filter = searchTerms.filter ? searchTerms.filter : '';
            vm.currentPage = searchTerms.currentPage > 1 ? searchTerms.currentPage : 1;
            vm.pageSize = searchTerms.pageSize >= pageSizeDefault ? searchTerms.pageSize : pageSizeDefault;
            loadVariantDetails();
        }
    }

    function loadVariantDetails() {
        loadSpinnerService.start('mainSpinner');
        console.log('loadVariantDetails', vm.currentPage);
        VariantsApiService.getVariantDetails($stateParams.variantId, vm.currentPage, vm.filter, vm.pageSize).then(function (response) {
            console.log('response', response.data);
            vm.variantDetails = response.data.results;
            vm.currentPage = response.data.page;
            vm.pageSize = response.data.limit;
            vm.totalItems = response.data.total;

            $stateParams.filter = vm.filter;
            $stateParams.currentPage = vm.currentPage;
            $stateParams.pageSize = vm.pageSize;
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner', {force: true});
        });
    }

    function enableEditing() {
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.isEditing = false;
    }

    function saveVariant() {
        updateVariant();
    }

    function searchTermChange() {
        if ($stateParams.filter !== vm.filter) {
            vm.currentPage = 1;
        }
        $stateParams.filter = vm.filter;
        $stateParams.currentPage = vm.currentPage;
        $stateParams.pageSize = vm.pageSize;
        loadVariantDetails();
    }

    function updateVariant() {

        var detailsToUpdate = [];

        _.forEach(vm.variantDetails, function(detail) {
            if (_.some(vm.orgDetails, {id: detail.id, statisticName: detail.statisticName, sortOrder: detail.sortOrder})) { return;}
            detailsToUpdate.push(detail);
        });

        loadSpinnerService.start('mainSpinner');
        VariantsApiService.updateVariantDetails(detailsToUpdate).then(function(response) {
            vm.isEditing = false;
        }, function(error) {
            console.log(error);
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function isAllInformationValid() {
        return true;
    }

}

angular
    .module('variants.variant', [])
    .config(stateConfig)
    .controller('VariantController', VariantController);
